import { selectTotalCount } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridTotalCount() {
  return useEagGridSelector(selectTotalCount);
}